import cn from 'classnames';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import ImageViewer from 'react-simple-image-viewer';
import { changeShipmentPosting } from '../../../../actions/postings';
import PostingsApi from '../../../../API/shipment/postings-api';
import default_image from '../../../../assets/media/icons/products.png';
import { Column, Row } from '../../../../components/Basic/Blocks';
import { NavLink } from '../../../../components/Basic/Elements';
import { Input, Select } from '../../../../components/Basic/Inputs';
import { TableCell, TableLine } from '../../../../components/Basic/Table';
import { TextGrey, Tooltip } from '../../../../components/Basic/WrapsStyle';
import ProviderList from '../../../../components/Common/Input/ProviderList';
import PostingStatusWrap from '../../../../components/Shipments/WrapStyle/PostingStatus';
import { DIFF_STATUSES, TO_POSING, TO_SHIPMENT } from '../../../../constans';
import { formFullDate, getDateMonth } from '../../../../utils';
import CommentPostingProductBlock from '../../Posting/CommentBlock';
import { WIDTH_POSTING } from '../index';
import styles from './styles.module.scss';

const STATE = {
  not_collected: { text: 'Не обработан', color: '' },
  not_started: { text: 'Не собран', color: '' },
  started: { text: 'Комплектуется', color: 'rgb(255 112 0 / 18%)' },
  collected: { text: 'Ожидает упаковки', color: 'rgb(88 143 255 / 37%)' },
  packed: { text: 'Упакован', color: 'rgb(69 255 156 / 51%)' },
  printed: { text: 'Упакован', color: '#39ee3f47' },
};

const PostingLine = ({
  shipmentMode = true,
  order = {},
  shipment = {},
  map = {},
  postingsPrint = {},
  changePostingPrint = (_) => _,
  printSticker = (_) => _,
  changePrintStatus = (_) => _,
  isAdmin = false,
  ...props
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const [images, setImages] = useState([]);

  const dispatch = useDispatch();

  const openImageViewer = (images) => {
    setImages(images);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  const onChangeProduct = async (id, productId, field, value, action = undefined) => {
    await PostingsApi.changeProductInPosting({ data: { postingNumber: id, productId, field, value, action } }).then((r) => {
      dispatch(changeShipmentPosting(r.posting));
    });
  };

  return (
    <TableLine key={order.number}>
      <TableCell width={WIDTH_POSTING[0]}>
        {isAdmin ? (
          <Link to={TO_POSING(order.posting_number)} className={styles.link} target="_blank">
            {order.posting_number}
          </Link>
        ) : (
          <>{order.posting_number} </>
        )}{' '}
        {order.market === 'wb' && <span className={styles.wb_sticker}>{order.sticker_parts?.second}</span>} <br />
        <Row style={{ width: '100%' }}>
          {order.market === 'wb' && <TextGrey style={{ fontSize: '18px', color: '#6c11c9' }}>{order.shop}</TextGrey>}
          {order.market === 'yandex' && (
            <TextGrey style={{ fontSize: '18px', color: 'rgb(193 61 0)' }}>{order.shop}</TextGrey>
          )}
          {order.market === 'ozon' && (
            <TextGrey style={{ fontSize: '18px', color: 'rgb(19,79,231)' }}>{order.shop}</TextGrey>
          )}
          {order.market === 'sber' && (
            <TextGrey style={{ fontSize: '18px', color: 'rgb(13,131,25)' }}>{order.shop}</TextGrey>
          )}
        </Row>
      </TableCell>
      <TableCell width={WIDTH_POSTING[12]} center>
        <NavLink
          to={TO_SHIPMENT(order.shipment_id)}
          target={'_blank'}
          className={styles.scan_time}
          style={{ fontSize: '18px' }}
        >
          {getDateMonth(order.dates.shipment_date)}
        </NavLink>
      </TableCell>
      <TableCell width={WIDTH_POSTING[1]}>
        <Column>
          {order.products.map((p, k) => {
            const data = map[p.offer_id] || {};
            const img = data.images ? (data.images.length > 0 ? data.images : [default_image]) : [default_image];
            const scan_time = p.scan_time ? formFullDate(p.scan_time) : null;
            return (
              <div key={k} className={styles.div_line_images}>
                <div className={styles.wrapper}>
                  <img
                    onClick={() => openImageViewer(img)}
                    className={styles.preview}
                    src={img.length > 0 ? img[0] : undefined}
                  />
                </div>
                <Column>
                  <div className={styles.name}>
                    {`${p.ordered_quantity} x ${p.name}  `}
                    <div className={cn(styles.offer_id, p.status === 'Нет в наличии' && styles.red_text)}>
                      {p.offer_id}
                    </div>
                  </div>
                  {scan_time && (
                    <div className={styles.scan_time}>
                      {scan_time} {p.scan_user && `(${p.scan_user})`}
                    </div>
                  )}
                </Column>
              </div>
            );
          })}
        </Column>
      </TableCell>
      <TableCell width={WIDTH_POSTING[4]} center={true}>
        <Column>
          {order.products.map((p, k) => (
            // eslint-disable-next-line react/no-array-index-key
            <Row key={`${order.posting_number}-${p.offer_id}-19`} className={styles.div_line} center={true}>
              {(p['diff'].comment || '').length > 0 ? (
                <Tooltip text={p['diff'].comment}>
                  {p.diff.status} {p['diff'].value !== 0 && p['diff'].value !== null && ` (${p['diff'].value})`} *
                </Tooltip>
              ) : (
                <>
                  {p['diff'].status} {p['diff'].value !== 0 && p['diff'].value !== null && ` (${p['diff'].value})`}
                </>
              )}
            </Row>
          ))}
        </Column>
      </TableCell>

      <TableCell width={WIDTH_POSTING[11]} center={true}>
        <Column>
          {order.products.map((p, k) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={k} className={styles.div_line}>
              <Select
                select={p.shipment_diff === 'Нет' ? null : p.shipment_diff}
                list={DIFF_STATUSES}
                style={{ fontSize: '16px' }}
                width={'188px'}
                onSelect={(v) => onChangeProduct(order.posting_number, p._id, 'shipment_diff', v === 'Нет' ? '' : v)}
                {...props}
              />
            </div>
          ))}
        </Column>
      </TableCell>
      <TableCell width={WIDTH_POSTING[4]}>
        <Column>
          {order.products.map((p, k) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={k} className={styles.div_line}>
              <CommentPostingProductBlock
                posting={order}
                offer_id={p.offer_id}
                onChange={(v) => {
                  onChangeProduct(order.posting_number, p._id, 'comment', v);
                }}
              />
            </div>
          ))}
        </Column>
      </TableCell>
      <TableCell width={WIDTH_POSTING[4]} center={true}>
        <Column>
          {order.products.map((p, k) => (
            <div key={k} className={styles.div_line}>
              <Input
                width={'100%'}
                value={p.variance_process?.upd}
                // disabled={!isAdmin}
                // center
                onBlur={(v) => onChangeProduct(order.posting_number, p._id, 'variance_upd', v)}
              />
            </div>
          ))}
        </Column>
      </TableCell>
      <TableCell width={WIDTH_POSTING[11]} center={true}>
        <Column>
          {order.products.map((p, k) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={k} className={styles.div_line}>
              <Select
                select={p.variance_process.status}
                list={[
                  'Оформлен',
                  'Вычерк',
                  'Не заказывали',
                  'Согласовали',
                  'Не согласовали',
                  'Занесли на склад',
                  'Товар отгружен',
                  'Нет',
                ]}
                style={{ fontSize: '16px' }}
                width={'200px'}
                onSelect={(v) => onChangeProduct(order.posting_number, p._id, 'variance_status', v === 'Нет' ? '' : v)}
                {...props}
              />
            </div>
          ))}
        </Column>
      </TableCell>
      <TableCell width={WIDTH_POSTING[0]} center={true}>
        <Column>
          {order.products.map((p, k) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={k} className={styles.div_line}>
              <Select
                select={p.variance_process.return}
                list={[
                  'Да',
                  'Нет',
                  'Отменить',
                ]}
                style={{ fontSize: '16px' }}
                width={'135px'}
                onSelect={(v) => onChangeProduct(order.posting_number, p._id, 'variance_return', v === 'Отменить' ? '' : v)}
                {...props}
              />
            </div>
          ))}
        </Column>
      </TableCell>

      <TableCell width={WIDTH_POSTING[4]} center={true}>
        <Column style={{ alignItems: 'center' }}>
          {order.products.map((p, k) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={k} className={styles.div_line} style={{ fontSize: '15px', fontWeight: '600' }}>
              {(map[p.offer_id] || {}).provider_artnumber}
            </div>
          ))}
        </Column>
      </TableCell>

      <TableCell width={WIDTH_POSTING[4]}>
        <Column style={{ alignItems: 'center' }}>
          {order.products.map((p, k) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={k} className={styles.div_line}>
              <ProviderList selectProviderId={p.provider_id} disabled={true} />
            </div>
          ))}
        </Column>
      </TableCell>

      <TableCell width={WIDTH_POSTING[4]} center={true}>
        <PostingStatusWrap order={order} />
      </TableCell>

      {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
    </TableLine>
  );
};

export default PostingLine;
